import { render, staticRenderFns } from "./verified_browsers.vue?vue&type=template&id=4b5c5d8e"
import script from "./verified_browsers.vue?vue&type=script&lang=js"
export * from "./verified_browsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports